<template>
  <privacy-policy :platform="platform"/>
</template>

<script>
import PrivacyPolicy from '@/components/PrivacyPolicy'

export default {
  name: 'Agree2',
  components: { PrivacyPolicy },
  computed: {
    platform () {
      const channel = this.$route.query.channel
      return ['general', 'huawei', 'vivo'].includes(channel) ? channel : 'general'
    }
  }
}
</script>
